import { getThemeColors } from '../../utils/chartTheme';

export const getOptions = () => {
    const tc = getThemeColors();
    return {
        maintainAspectRatio: true,
        responsive: true,
        title: {
            display: true,
            text: ''
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let value = context.chart.data.datasets[0].data[context.dataIndex];
                        let value2 = context.chart.data.datasets[1].data[context.dataIndex];
                        let date = context.chart.data.labels[context.dataIndex];
                        let newlabel = parseInt(value + value2) + ' € im Jahr ' + date;
                        return [newlabel];
                    }
                }
            },
            datalabels: {
                anchor: 'center',
                color: function (context) {
                    var value = context.dataset.data[context.dataIndex];
                    return value > 200 ? '#fff' : tc.datalabelColor;
                },
                align: 'center',
                display: true,
                formatter: Math.round,
                font: {
                    weight: 'normal'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    autoSkip: false,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: 'Year',
                    color: tc.textColor
                }
            },
            y: {
                stacked: true,
                grid: { color: tc.gridColor },
                ticks: {
                    beginAtZero: true,
                    color: tc.textColor
                },
                title: {
                    display: true,
                    text: '€',
                    color: tc.textColor
                }
            }
        }
    };
};
